"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auth/device.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauth%2Fdevice.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceCheckDecisionToJSON = exports.deviceCheckDecisionFromJSON = exports.authEventToJSON = exports.authEventFromJSON = exports.deviceCheckProviderToJSON = exports.deviceCheckProviderFromJSON = exports.deviceOsToJSON = exports.deviceOsFromJSON = exports.DeviceCheck = exports.DeviceDisplay = exports.Browser = exports.MobileDevice = exports.DeviceRisk = exports.Device = exports.DeviceCheckDecision = exports.AuthEvent = exports.DeviceCheckProvider = exports.DeviceOs = void 0;
const device_provider_1 = require("../common/device-provider");
const protobufPackage = 'com.step.auth.proto';
var DeviceOs;
(function (DeviceOs) {
    DeviceOs["INVALID_DEVICE_OS"] = "INVALID_DEVICE_OS";
    DeviceOs["IOS"] = "IOS";
    DeviceOs["ANDROID"] = "ANDROID";
    DeviceOs["MAC_OSX"] = "MAC_OSX";
    DeviceOs["LINUX"] = "LINUX";
    DeviceOs["WINDOWS"] = "WINDOWS";
    DeviceOs["CHROME_OS"] = "CHROME_OS";
    DeviceOs["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DeviceOs || (exports.DeviceOs = DeviceOs = {}));
var DeviceCheckProvider;
(function (DeviceCheckProvider) {
    DeviceCheckProvider["INVALID_DEVICE_CHECK_PROVIDER"] = "INVALID_DEVICE_CHECK_PROVIDER";
    DeviceCheckProvider["ALLOY"] = "ALLOY";
    DeviceCheckProvider["BYPASS"] = "BYPASS";
    DeviceCheckProvider["DEVICE_KEY"] = "DEVICE_KEY";
    DeviceCheckProvider["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DeviceCheckProvider || (exports.DeviceCheckProvider = DeviceCheckProvider = {}));
var AuthEvent;
(function (AuthEvent) {
    AuthEvent["INVALID_AUTH_EVENT"] = "INVALID_AUTH_EVENT";
    AuthEvent["SIGNUP"] = "SIGNUP";
    AuthEvent["RECOVERY"] = "RECOVERY";
    /**
     * KEY_LOGIN - Login using registered authentication keys
     */
    AuthEvent["KEY_LOGIN"] = "KEY_LOGIN";
    AuthEvent["ALIAS_VERIFICATION"] = "ALIAS_VERIFICATION";
    AuthEvent["PARTNER_LOGIN"] = "PARTNER_LOGIN";
    AuthEvent["UNRECOGNIZED"] = "UNRECOGNIZED";
})(AuthEvent || (exports.AuthEvent = AuthEvent = {}));
var DeviceCheckDecision;
(function (DeviceCheckDecision) {
    DeviceCheckDecision["INVALID_DECISION"] = "INVALID_DECISION";
    DeviceCheckDecision["APPROVED"] = "APPROVED";
    DeviceCheckDecision["DENIED"] = "DENIED";
    DeviceCheckDecision["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DeviceCheckDecision || (exports.DeviceCheckDecision = DeviceCheckDecision = {}));
function createBaseDevice() {
    return {
        id: '',
        providerDeviceId: '',
        provider: device_provider_1.DeviceProvider.INVALID_DEVICE_PROVIDER,
        os: DeviceOs.INVALID_DEVICE_OS,
        mobile: undefined,
        browser: undefined,
        firstSeenMs: '0',
        lastUsedAtMs: '0',
        blockedAtMs: '0',
        risk: undefined,
        display: undefined,
    };
}
exports.Device = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            providerDeviceId: isSet(object.providerDeviceId)
                ? globalThis.String(object.providerDeviceId)
                : '',
            provider: isSet(object.provider)
                ? (0, device_provider_1.deviceProviderFromJSON)(object.provider)
                : device_provider_1.DeviceProvider.INVALID_DEVICE_PROVIDER,
            firstSeenMs: isSet(object.firstSeenMs) ? globalThis.String(object.firstSeenMs) : '0',
        };
        if (isSet(object.os)) {
            message.os = deviceOsFromJSON(object.os);
        }
        if (isSet(object.mobile)) {
            message.mobile = exports.MobileDevice.fromJSON(object.mobile);
        }
        if (isSet(object.browser)) {
            message.browser = exports.Browser.fromJSON(object.browser);
        }
        if (isSet(object.lastUsedAtMs)) {
            message.lastUsedAtMs = globalThis.String(object.lastUsedAtMs);
        }
        if (isSet(object.blockedAtMs)) {
            message.blockedAtMs = globalThis.String(object.blockedAtMs);
        }
        if (isSet(object.risk)) {
            message.risk = exports.DeviceRisk.fromJSON(object.risk);
        }
        if (isSet(object.display)) {
            message.display = exports.DeviceDisplay.fromJSON(object.display);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.providerDeviceId !== '') {
            obj.providerDeviceId = message.providerDeviceId;
        }
        if (message.provider !== device_provider_1.DeviceProvider.INVALID_DEVICE_PROVIDER) {
            obj.provider = (0, device_provider_1.deviceProviderToJSON)(message.provider);
        }
        if (message.os !== undefined && message.os !== DeviceOs.INVALID_DEVICE_OS) {
            obj.os = deviceOsToJSON(message.os);
        }
        if (message.mobile !== undefined) {
            obj.mobile = exports.MobileDevice.toJSON(message.mobile);
        }
        if (message.browser !== undefined) {
            obj.browser = exports.Browser.toJSON(message.browser);
        }
        if (message.firstSeenMs !== '0') {
            obj.firstSeenMs = message.firstSeenMs;
        }
        if (message.lastUsedAtMs !== undefined && message.lastUsedAtMs !== '0') {
            obj.lastUsedAtMs = message.lastUsedAtMs;
        }
        if (message.blockedAtMs !== undefined && message.blockedAtMs !== '0') {
            obj.blockedAtMs = message.blockedAtMs;
        }
        if (message.risk !== undefined) {
            obj.risk = exports.DeviceRisk.toJSON(message.risk);
        }
        if (message.display !== undefined) {
            obj.display = exports.DeviceDisplay.toJSON(message.display);
        }
        return obj;
    },
    create(base) {
        return exports.Device.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDevice();
        message.id = object.id ?? '';
        message.providerDeviceId = object.providerDeviceId ?? '';
        message.provider = object.provider ?? device_provider_1.DeviceProvider.INVALID_DEVICE_PROVIDER;
        message.os = object.os ?? DeviceOs.INVALID_DEVICE_OS;
        message.mobile = (object.mobile !== undefined && object.mobile !== null)
            ? exports.MobileDevice.fromPartial(object.mobile)
            : undefined;
        message.browser = (object.browser !== undefined && object.browser !== null)
            ? exports.Browser.fromPartial(object.browser)
            : undefined;
        message.firstSeenMs = object.firstSeenMs ?? '0';
        message.lastUsedAtMs = object.lastUsedAtMs ?? '0';
        message.blockedAtMs = object.blockedAtMs ?? '0';
        message.risk = (object.risk !== undefined && object.risk !== null)
            ? exports.DeviceRisk.fromPartial(object.risk)
            : undefined;
        message.display = (object.display !== undefined && object.display !== null)
            ? exports.DeviceDisplay.fromPartial(object.display)
            : undefined;
        return message;
    },
};
function createBaseDeviceRisk() {
    return { isEmulator: false, isNonUsCarrier: false };
}
exports.DeviceRisk = {
    fromJSON(object) {
        const message = {
            isEmulator: isSet(object.isEmulator) ? globalThis.Boolean(object.isEmulator) : false,
            isNonUsCarrier: isSet(object.isNonUsCarrier)
                ? globalThis.Boolean(object.isNonUsCarrier)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isEmulator !== false) {
            obj.isEmulator = message.isEmulator;
        }
        if (message.isNonUsCarrier !== false) {
            obj.isNonUsCarrier = message.isNonUsCarrier;
        }
        return obj;
    },
    create(base) {
        return exports.DeviceRisk.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeviceRisk();
        message.isEmulator = object.isEmulator ?? false;
        message.isNonUsCarrier = object.isNonUsCarrier ?? false;
        return message;
    },
};
function createBaseMobileDevice() {
    return { brand: '', model: '' };
}
exports.MobileDevice = {
    fromJSON(object) {
        const message = {
            brand: isSet(object.brand) ? globalThis.String(object.brand) : '',
            model: isSet(object.model) ? globalThis.String(object.model) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.brand !== '') {
            obj.brand = message.brand;
        }
        if (message.model !== '') {
            obj.model = message.model;
        }
        return obj;
    },
    create(base) {
        return exports.MobileDevice.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMobileDevice();
        message.brand = object.brand ?? '';
        message.model = object.model ?? '';
        return message;
    },
};
function createBaseBrowser() {
    return { type: '' };
}
exports.Browser = {
    fromJSON(object) {
        const message = { type: isSet(object.type) ? globalThis.String(object.type) : '' };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== '') {
            obj.type = message.type;
        }
        return obj;
    },
    create(base) {
        return exports.Browser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBrowser();
        message.type = object.type ?? '';
        return message;
    },
};
function createBaseDeviceDisplay() {
    return { text: '', shortText: '' };
}
exports.DeviceDisplay = {
    fromJSON(object) {
        const message = {
            text: isSet(object.text) ? globalThis.String(object.text) : '',
            shortText: isSet(object.shortText) ? globalThis.String(object.shortText) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== '') {
            obj.text = message.text;
        }
        if (message.shortText !== '') {
            obj.shortText = message.shortText;
        }
        return obj;
    },
    create(base) {
        return exports.DeviceDisplay.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeviceDisplay();
        message.text = object.text ?? '';
        message.shortText = object.shortText ?? '';
        return message;
    },
};
function createBaseDeviceCheck() {
    return {
        event: AuthEvent.INVALID_AUTH_EVENT,
        provider: DeviceCheckProvider.INVALID_DEVICE_CHECK_PROVIDER,
        decision: DeviceCheckDecision.INVALID_DECISION,
        decisionAtMs: '0',
    };
}
exports.DeviceCheck = {
    fromJSON(object) {
        const message = {
            provider: isSet(object.provider)
                ? deviceCheckProviderFromJSON(object.provider)
                : DeviceCheckProvider.INVALID_DEVICE_CHECK_PROVIDER,
            decision: isSet(object.decision)
                ? deviceCheckDecisionFromJSON(object.decision)
                : DeviceCheckDecision.INVALID_DECISION,
            decisionAtMs: isSet(object.decisionAtMs) ? globalThis.String(object.decisionAtMs) : '0',
        };
        if (isSet(object.event)) {
            message.event = authEventFromJSON(object.event);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.event !== undefined && message.event !== AuthEvent.INVALID_AUTH_EVENT) {
            obj.event = authEventToJSON(message.event);
        }
        if (message.provider !== DeviceCheckProvider.INVALID_DEVICE_CHECK_PROVIDER) {
            obj.provider = deviceCheckProviderToJSON(message.provider);
        }
        if (message.decision !== DeviceCheckDecision.INVALID_DECISION) {
            obj.decision = deviceCheckDecisionToJSON(message.decision);
        }
        if (message.decisionAtMs !== '0') {
            obj.decisionAtMs = message.decisionAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.DeviceCheck.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDeviceCheck();
        message.event = object.event ?? AuthEvent.INVALID_AUTH_EVENT;
        message.provider = object.provider ?? DeviceCheckProvider.INVALID_DEVICE_CHECK_PROVIDER;
        message.decision = object.decision ?? DeviceCheckDecision.INVALID_DECISION;
        message.decisionAtMs = object.decisionAtMs ?? '0';
        return message;
    },
};
function deviceOsFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DEVICE_OS':
            return DeviceOs.INVALID_DEVICE_OS;
        case 1:
        case 'IOS':
            return DeviceOs.IOS;
        case 2:
        case 'ANDROID':
            return DeviceOs.ANDROID;
        case 3:
        case 'MAC_OSX':
            return DeviceOs.MAC_OSX;
        case 4:
        case 'LINUX':
            return DeviceOs.LINUX;
        case 5:
        case 'WINDOWS':
            return DeviceOs.WINDOWS;
        case 6:
        case 'CHROME_OS':
            return DeviceOs.CHROME_OS;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DeviceOs.UNRECOGNIZED;
    }
}
exports.deviceOsFromJSON = deviceOsFromJSON;
function deviceOsToJSON(object) {
    switch (object) {
        case DeviceOs.INVALID_DEVICE_OS:
            return 'INVALID_DEVICE_OS';
        case DeviceOs.IOS:
            return 'IOS';
        case DeviceOs.ANDROID:
            return 'ANDROID';
        case DeviceOs.MAC_OSX:
            return 'MAC_OSX';
        case DeviceOs.LINUX:
            return 'LINUX';
        case DeviceOs.WINDOWS:
            return 'WINDOWS';
        case DeviceOs.CHROME_OS:
            return 'CHROME_OS';
        case DeviceOs.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.deviceOsToJSON = deviceOsToJSON;
function deviceCheckProviderFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DEVICE_CHECK_PROVIDER':
            return DeviceCheckProvider.INVALID_DEVICE_CHECK_PROVIDER;
        case 1:
        case 'ALLOY':
            return DeviceCheckProvider.ALLOY;
        case 2:
        case 'BYPASS':
            return DeviceCheckProvider.BYPASS;
        case 3:
        case 'DEVICE_KEY':
            return DeviceCheckProvider.DEVICE_KEY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DeviceCheckProvider.UNRECOGNIZED;
    }
}
exports.deviceCheckProviderFromJSON = deviceCheckProviderFromJSON;
function deviceCheckProviderToJSON(object) {
    switch (object) {
        case DeviceCheckProvider.INVALID_DEVICE_CHECK_PROVIDER:
            return 'INVALID_DEVICE_CHECK_PROVIDER';
        case DeviceCheckProvider.ALLOY:
            return 'ALLOY';
        case DeviceCheckProvider.BYPASS:
            return 'BYPASS';
        case DeviceCheckProvider.DEVICE_KEY:
            return 'DEVICE_KEY';
        case DeviceCheckProvider.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.deviceCheckProviderToJSON = deviceCheckProviderToJSON;
function authEventFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_AUTH_EVENT':
            return AuthEvent.INVALID_AUTH_EVENT;
        case 1:
        case 'SIGNUP':
            return AuthEvent.SIGNUP;
        case 2:
        case 'RECOVERY':
            return AuthEvent.RECOVERY;
        case 3:
        case 'KEY_LOGIN':
            return AuthEvent.KEY_LOGIN;
        case 4:
        case 'ALIAS_VERIFICATION':
            return AuthEvent.ALIAS_VERIFICATION;
        case 5:
        case 'PARTNER_LOGIN':
            return AuthEvent.PARTNER_LOGIN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AuthEvent.UNRECOGNIZED;
    }
}
exports.authEventFromJSON = authEventFromJSON;
function authEventToJSON(object) {
    switch (object) {
        case AuthEvent.INVALID_AUTH_EVENT:
            return 'INVALID_AUTH_EVENT';
        case AuthEvent.SIGNUP:
            return 'SIGNUP';
        case AuthEvent.RECOVERY:
            return 'RECOVERY';
        case AuthEvent.KEY_LOGIN:
            return 'KEY_LOGIN';
        case AuthEvent.ALIAS_VERIFICATION:
            return 'ALIAS_VERIFICATION';
        case AuthEvent.PARTNER_LOGIN:
            return 'PARTNER_LOGIN';
        case AuthEvent.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.authEventToJSON = authEventToJSON;
function deviceCheckDecisionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DECISION':
            return DeviceCheckDecision.INVALID_DECISION;
        case 1:
        case 'APPROVED':
            return DeviceCheckDecision.APPROVED;
        case 2:
        case 'DENIED':
            return DeviceCheckDecision.DENIED;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DeviceCheckDecision.UNRECOGNIZED;
    }
}
exports.deviceCheckDecisionFromJSON = deviceCheckDecisionFromJSON;
function deviceCheckDecisionToJSON(object) {
    switch (object) {
        case DeviceCheckDecision.INVALID_DECISION:
            return 'INVALID_DECISION';
        case DeviceCheckDecision.APPROVED:
            return 'APPROVED';
        case DeviceCheckDecision.DENIED:
            return 'DENIED';
        case DeviceCheckDecision.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.deviceCheckDecisionToJSON = deviceCheckDecisionToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=device.js.map